import { render, staticRenderFns } from "./TestOverview.vue?vue&type=template&id=188460f6&"
import script from "./TestOverview.vue?vue&type=script&lang=js&"
export * from "./TestOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports